import ApiService from './ApiService'

export const RequestService = {

  baseURL: process.env.VUE_APP_EVOCALL_URL,

  query (params) {
    return new Promise((resolve, reject) => {
      ApiService.query(`${this.baseURL}/requests`, params)
        .then(response => resolve(response.data))
        .catch(errors => reject(errors))
    })
  },

  get (slug, params = {}) {
    return new Promise((resolve, reject) => {
      ApiService.get(`${this.baseURL}/requests`, slug, params)
        .then(response => resolve(response.data.data))
        .catch(errors => reject(errors))
    })
  },

  getSources (params = {}) {
    return new Promise((resolve, reject) => {
      ApiService.query(`${this.baseURL}/requests/sources`, params)
        .then(response => resolve(response.data.data))
        .catch(errors => reject(errors))
    })
  },

  getTypes (params = {}) {
    return new Promise((resolve, reject) => {
      ApiService.query(`${this.baseURL}/requests/types`, params)
        .then(response => resolve(response.data.data))
        .catch(errors => reject(errors))
    })
  },

  getFromPerson (personId, params = {}) {
    return new Promise((resolve, reject) => {
      ApiService.query(`${this.baseURL}/people/${personId}/requests`, params)
        .then(response => resolve(response.data.data))
        .catch(errors => reject(errors))
    })
  },

  store (data) {
    return new Promise((resolve, reject) => {
      ApiService.post(`${this.baseURL}/requests`, data)
        .then(response => {
          //console.log('response', response.data)
          resolve(response.data.data)
        }).catch(errors => {
          reject(errors)
        })
    })
  },

  accept (resource) {
    return new Promise((resolve, reject) => {
      ApiService.patch(`${this.baseURL}/requests/${resource}/accept`)
        .then(response => resolve(response.data.data))
        .catch(errors => reject(errors))
    })
  },

  requeue (resource) {
    return new Promise((resolve, reject) => {
      ApiService.patch(`${this.baseURL}/requests/${resource}/requeue`)
        .then(response => resolve(response.data.data))
        .catch(errors => reject(errors))
    })
  },

  end (resource) {
    return new Promise((resolve, reject) => {
      ApiService.patch(`${this.baseURL}/requests/${resource}/end`)
        .then(response => resolve(response.data.data))
        .catch(errors => reject(errors))
    })
  },

  rate (resource, data) {
    return new Promise((resolve, reject) => {
      ApiService.patch(`${this.baseURL}/requests/${resource}/rate`, data)
        .then(response => resolve(response.data.data))
        .catch(errors => reject(errors))
    })
  },

  conclude (resource) {
    return new Promise((resolve, reject) => {
      ApiService.patch(`${this.baseURL}/requests/${resource}/conclude`)
        .then(response => resolve(response.data.data))
        .catch(errors => reject(errors))
    })
  },

  cancel (resource, data) {
    return new Promise((resolve, reject) => {
      ApiService.patch(`${this.baseURL}/requests/${resource}/cancel`, data)
        .then(response => resolve(response.data.data))
        .catch(errors => reject(errors))
    })
  },

  update (resource, params) {
    return new Promise((resolve, reject) => {
      ApiService.patch(`${this.baseURL}/requests/${resource}`, params)
        .then(response => resolve(response.data.data))
        .catch(errors => reject(errors))
    })
  },

  updatePriority (resource, params) {
    return new Promise((resolve, reject) => {
      ApiService.patch(`${this.baseURL}/requests/${resource}/priority`, params)
        .then(response => resolve(response.data.data))
        .catch(errors => reject(errors))
    })
  },

  updateObservations (resource, params) {
    return new Promise((resolve, reject) => {
      ApiService.patch(`${this.baseURL}/requests/${resource}/observations`, params)
        .then(response => resolve(response.data.data))
        .catch(errors => reject(errors))
    })
  },

  destroy (resource, params) {
    return ApiService.delete(`${this.baseURL}/requests/${resource}`)
  }
}

export const MetricsService = {

  baseURL: process.env.VUE_APP_EVOCALL_URL,

  query (params) {
    return new Promise((resolve, reject) => {
      ApiService.query(`${this.baseURL}/metrics`, params)
        .then(response => resolve(response.data.data))
        .catch(errors => reject(errors))
    })
  },
}

export const BreakService = {

  baseURL: process.env.VUE_APP_EVOCALL_URL,

  startBreak () {
    return new Promise((resolve, reject) => {
      ApiService.post(`${this.baseURL}/breaks/start-break`)
        .then(response => resolve(response.data.data))
        .catch(errors => reject(errors))
    })
  },

  endBreak (resource) {
    return new Promise((resolve, reject) => {
      ApiService.patch(`${this.baseURL}/breaks/end-break/${resource}`)
        .then(response => resolve(response.data.data))
        .catch(errors => reject(errors))
    })
  }
}

export const MyService = {

  baseURL: process.env.VUE_APP_EVOCALL_URL,

  getActiveBreak (params = {}) {
    return new Promise((resolve, reject) => {
      ApiService.query(`${this.baseURL}/me/active-break`, params)
        .then(response => resolve(response.data.data))
        .catch(errors => reject(errors))
    })
  },

  getActiveRequest (params = {}) {
    return new Promise((resolve, reject) => {
      ApiService.query(`${this.baseURL}/me/active-request`, params)
        .then(response => resolve(response.data.data))
        .catch(errors => reject(errors))
    })
  },

  getPendingRequest (params = {}) {
    return new Promise((resolve, reject) => {
      ApiService.query(`${this.baseURL}/me/pending-request`, params)
        .then(response => resolve(response.data.data))
        .catch(errors => reject(errors))
    })
  }

}
